import { useGetFormConfigQuery } from '@/features/config/configApi';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { FormGroup, FormLabel, Grid, Stack, Tooltip, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FolioCheckbox from '@/components/FolioCheckbox';
import { useClientSchemaContext } from '@/context/clientSchemaContext';
import { isProspectFieldVisible } from '@/features/config/helper';

const GROUP = 'clientCategory';

const ClientCategoryFields = ({ disabled }) => {
	const theme = useTheme();
	const { values, setFieldValue } = useFormikContext();
	const { view, isProspect } = useClientSchemaContext();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails, isLoading } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);

	const fieldsQuery = useGetFormConfigQuery(
		{ configType: 'client' },
		{
			skip: !userDetails,
			selectFromResult: ({ data, ...rest }) => ({
				...rest,
				data:
					data?.filter(
						(f) =>
							f.group === GROUP &&
							(isProspect ? isProspectFieldVisible(f, view) : f.visible?.[view]),
					) ?? [],
			}),
		},
	);

	const fields = useMemo(() => {
		const data = (fieldsQuery.data ?? []).slice();
		return data.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
	}, [fieldsQuery.data]);

	if (fields.length === 0) return <></>;

	return (
		<FormGroup width='100%'>
			<FormLabel disabled={disabled}>Client category</FormLabel>
			<Grid container rowSpacing={1} columnSpacing={2}>
				{fields.map((field) => {
					const options = field.field?.options;
					const helperText = field.helperText;
					return (
						<Grid size={{ xs: 12, sm: 6 }} key={`client-category-${field.name}`}>
							<FolioCheckbox
								checked={values[field.name] == options?.true}
								label={
									helperText ? (
										<Stack
											direction='row'
											justifyContent='space-between'
											alignItems='center'
											spacing={1}
										>
											<span>{field.label}</span>

											<Tooltip title={helperText}>
												<InfoOutlineIcon
													fontSize='1.25rem'
													sx={{ color: theme.palette.text.secondary }}
												/>
											</Tooltip>
										</Stack>
									) : (
										field.label
									)
								}
								onChange={() => {
									const checked = values[field.name] == options.true;
									setFieldValue(
										field.name,
										checked ? options.false : options.true,
									);
								}}
								disabled={isLoading || disabled}
							/>
						</Grid>
					);
				})}
			</Grid>
		</FormGroup>
	);
};
export default ClientCategoryFields;
